import { api } from '@/core/api/';

const BaseUrl = '/api/account';

export const getUserMenu = async () => {
  try {
    const { data } = await api.get(`${BaseUrl}/sitemap/`);
    return data;
  } catch {
    return [];
  }
};
export const completeUserAgreement = (userId) =>
  api.post(`${BaseUrl}/useragreement`, { userId });

export const getAdditionalProfileInfo = async () => {
  try {
    const { data } = await api.get(`${BaseUrl}/getprofileinformation/`);
    if (data) {
      const { companies, permissions, user } = data;

      return {
        companies: (companies || []).map(
          ({
            id,
            name,
            socialSecurityNo,
            isMainCompany,
            providerTypeId,
            providerTypeName,
          }) => ({
            id,
            name,
            ssn: socialSecurityNo,
            main: isMainCompany,
            providerTypeId,
            providerTypeName,
          })
        ),
        permissions,
        userProfile: user,
      };
    }

    return null;
  } catch {
    return null;
  }
};
